import { render, staticRenderFns } from "./PreferentialList.vue?vue&type=template&id=5e83845d&scoped=true&"
import script from "./PreferentialList.vue?vue&type=script&lang=js&"
export * from "./PreferentialList.vue?vue&type=script&lang=js&"
import style0 from "./PreferentialList.vue?vue&type=style&index=0&id=5e83845d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83845d",
  null
  
)

export default component.exports